module.exports = __webpack_public_path__ + "static/media/roble_gris.2bde8e9d.jpg";